import { CircularProgress, ThemeProvider } from "@material-ui/core";
import { InsightsIcon } from "../../Icons/InsightsIcon";
import React from "react";
import { groupDarkTheme } from "../../styles/MaterialGroopTheme";

interface AiLoadingComponentProps {
  loading: boolean;
  clicked?: () => void;
  shouldHover?: boolean;
  showAiIcon?: boolean;
}

export const AiLoadingComponent = (props: AiLoadingComponentProps) => {
  const [isMousedOver, setIsMousedOver] = React.useState(false);
  const [showAiIcon] = React.useState(props.showAiIcon ?? true);

  return (
    <ThemeProvider theme={groupDarkTheme}>
      <div
        className="relative inline-flex"
        onMouseEnter={() =>
          !props.loading && props.shouldHover && setIsMousedOver(true)
        }
        onMouseLeave={() =>
          !props.loading && props.shouldHover && setIsMousedOver(false)
        }
      >
        {props.loading ? (
          <CircularProgress aria-label="Indeterminate loading spinner." />
        ) : (
          <CircularProgress
            aria-label="Hover indicator"
            variant="determinate"
            value={100}
            thickness={2}
            className={isMousedOver ? "" : "invisible"}
          />
        )}
        <div
          className={`inset-0 absolute flex items-center justify-center ${
            showAiIcon ? "" : "invisible"
          }`}
          aria-label="Insights icon container"
        >
          <InsightsIcon
            onClick={props.clicked}
            color="primary"
            aria-label="AI insights icon"
          />
        </div>
      </div>
    </ThemeProvider>
  );
};
